<template>
  <div class="icon-close" />
</template>

<style scoped>
.icon-close {
  display: flex;
  align-items: center;
  position: relative;
  width: 20px;
  height: 20px;

  &:hover {
    opacity: 0.7;
  }

  &::before,
  &::after {

    position: absolute;
    width: 25px;
    height: 3px;
    content: "";
    background-color: rgb(var(--v-theme-ui-white));
    border-radius: 2px;
  }

  &::before {
    transform: rotateZ(45deg);
  }

  &::after {
    transform: rotateZ(-45deg);
  }
}
</style>
